export default __webpack_public_path__ + "static/media/Ios.a09e574e.svg";